<template>
  <div class="item" :class="{ failed: error }">
    <label v-if="label" :for="id" class="block font-bold uppercase mb-1">
      {{ label }}
      <span v-if="required">*</span>
    </label>
    <input
      :id="id"
      :type="type"
      :placeholder="placeholder"
      v-bind="$attrs"
      class="form-control"
      :value="modelValue"
      @input="$emit('update:modelValue', $event.target.value)"
    />
  </div>
</template>
<script>
export default {
  name: 'TextField',
  props: {
    id: {
      type: [String, Number],
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    modelValue: String,
  },
  emits: ['update:modelValue'],
}
</script>
